import maxLength from '../../../../v2/form/field-validation/max-length';
import minEntropy from '../../../../v2/form/field-validation/minEntropy';
import minLength from '../../../../v2/form/field-validation/minLength';
import minLower from '../../../../v2/form/field-validation/minLower';
import minNumeric from '../../../../v2/form/field-validation/minNumeric';
import minSpecial from '../../../../v2/form/field-validation/minSpecialChars';
import minUpper from '../../../../v2/form/field-validation/minUpper';
import required from '../../../../v2/form/field-validation/required';

const fieldName = 'password';

const getPasswordFieldDefinition = passwordRules => ({
  name: fieldName,
  label: fieldName,
  required: true,
  validate: [
    required(fieldName),
    minLength(passwordRules.minLength, fieldName),
    maxLength(passwordRules.maxLength, fieldName),
    minUpper(passwordRules.minUpper, fieldName),
    minLower(passwordRules.minLower, fieldName),
    minNumeric(passwordRules.minNumeric, fieldName),
    minSpecial(passwordRules.minSpecial, fieldName),
    minEntropy(passwordRules.minEntropy, fieldName),
  ],
  xssCheckExempt: true,
  maxLength: passwordRules.maxLength,
  autoComplete: 'new-password',
  type: fieldName,
});

export default getPasswordFieldDefinition;
